<div class="round-dialog">
  <header>
    <h2 mat-dialog-title class="round-dialog__title">{{ 'testRunExecutions.runnerDialog.title' | translate }}</h2>
    <p class="round-dialog__subtitle">
      @if (data.runKey) {
        <code>{{ data.runKey }}</code>
      }
      {{ data.runName }}
    </p>
  </header>

  <mat-dialog-content class="round-dialog__content">
    <app-runner-target-select (targetChange)="target.set($event)" (connect)="cancel()" />
  </mat-dialog-content>

  <mat-dialog-actions class="round-dialog__actions">
    <button mat-stroked-button type="button" data-testid="round-cancel" (click)="cancel()">
      {{ 'common.cancel' | translate }}
    </button>
    <button
      mat-flat-button
      type="button"
      class="round-dialog__start"
      data-testid="round-start"
      [disabled]="target() === null"
      (click)="start()"
    >
      <mat-icon aria-hidden="true">play_arrow</mat-icon>
      {{ 'testRunExecutions.runnerDialog.start' | translate }}
    </button>
  </mat-dialog-actions>
</div>
